import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "pigpelt";

function GIPigPelt() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIPigPelt;